import React from 'react'
import InlineTextEditor from '../../inline-editors/InlineTextEditor'
import { CellBaseProps, resolveOverrideContext, isFieldEditing, makeEditClickHandler, makeFieldSaveHandler, overrideEditableClass } from './types'

/**
 * Renders the AFTT (Airframe Total Time) column cell.
 */
export function AFTTCell(props: CellBaseProps) {
  const { cellBorderClass, effectiveAircraft, aircraftTransaction } = props
  const { isSoldWithTransaction, isEditable, transOverride, override } = resolveOverrideContext(props)

  const hasOverride = isSoldWithTransaction
    ? (transOverride?.aftt != null)
    : (override?.aftt != null)

  const currentValue = isSoldWithTransaction
    ? (transOverride?.aftt ?? aircraftTransaction!?.aftt ?? null)
    : (override?.aftt ?? effectiveAircraft.aftt ?? null)

  const isEditing = isFieldEditing(props, 'aftt', isSoldWithTransaction)

  return (
    <td className={`px-2 py-2 text-sm text-gray-900 text-center ${cellBorderClass}`}>
      <div
        className={overrideEditableClass(hasOverride, isEditable)}
        onClick={makeEditClickHandler(props, 'aftt', isEditable, isSoldWithTransaction)}
      >
        {isEditing ? (
          <InlineTextEditor
            value={currentValue}
            fieldName="aftt"
            inputType="number"
            min={0}
            placeholder="0"
            onSave={makeFieldSaveHandler(props, 'aftt', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
          />
        ) : (
          effectiveAircraft.aftt !== null ? effectiveAircraft.aftt.toLocaleString() : '-'
        )}
      </div>
    </td>
  )
}

